module.exports = __webpack_public_path__ + "media/icons/switch-on-orange-ba005902.svg";